import React from 'react';

/**
 * Labeled form control: icon + label + required + control slot + hint/error.
 *
 * @param {object} props
 * @param {string} props.label
 * @param {string} [props.htmlFor]
 * @param {React.ReactNode} [props.icon]
 * @param {boolean} [props.required]
 * @param {string} [props.hint]
 * @param {string} [props.error]
 * @param {React.ReactNode} props.children — the control (Input, Select, etc.)
 * @param {string} [props.className]
 */
export default function Field({
  label,
  htmlFor,
  icon,
  required = false,
  hint,
  error,
  children,
  className = '',
}) {
  return (
    <div className={className}>
      <label
        htmlFor={htmlFor}
        className="block font-display text-lg font-semibold text-critic-text-primary mb-4 flex items-center space-x-2"
      >
        {icon}
        <span>{label}</span>
        {required && <span className="text-apple-error">*</span>}
      </label>
      {children}
      {(hint || error) && (
        <p
          className={`mt-2 text-sm font-normal ${
            error ? 'text-apple-error' : 'text-critic-text-muted'
          }`}
        >
          {error || hint}
        </p>
      )}
    </div>
  );
}
